import api from "./axios"; // axios déjà configuré avec baseURL

export const getEntretiens = () => api.get("/types-entretien");       
export const getEntretienstech = () => api.get("/types-entretien/tech");
export const getEntretienById = (id) => api.get(`/types-entretien/${id}`);

export const createEntretien = async (data) => {
  try {
    const res = await api.post("/types-entretien", data);
    console.log("Type d'entretien créé :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la création :", ex.response ? ex.response.data : ex);
  }
};

export const updateEntretien = async (id, data) => {
  try {
    const res = await api.put(`/types-entretien/${id}`, data);
    console.log("Type d'entretien mis à jour :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la mise à jour :", ex.response ? ex.response.data : ex);
  }
};

export const deleteEntretien = async (id) => {
  try {
    const res = await api.delete(`/types-entretien/${id}`);
    console.log("Type d'entretien supprimé :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la suppression :", ex.response ? ex.response.data : ex);
  }
};
